import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useKits } from "@/hooks/useKits";
import { KitSelector } from "@/components/KitSelector";
import { useToast } from "@/hooks/use-toast";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@/components/ui/button";
import { UserProfile } from "@/components/auth/UserProfile";

export default function Index() {
  const { kits } = useKits();
  const [activeKit, setActiveKit] = useState<string | null>(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  const handleKitSelect = (kitId: string) => {
    setActiveKit(kitId);
    setHasUnsavedChanges(true);
    toast({
      title: "Kit Selected",
      description: `Select Apply Changes to navigate to kit control...`,
      className: "bg-[#1A1F2C] border border-white/10 text-white",
    });
  };

  const handleApplyChanges = () => {
    setHasUnsavedChanges(false);
    if (activeKit) {
      navigate(`/kit-control/${activeKit}`);
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-ticker-bg text-ticker-text flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold mb-4">Welcome to Sports Ticker Control</h1>
          <p className="mb-8 text-lg">Please log in to continue</p>
          <Button 
            onClick={() => loginWithRedirect()}
            className="bg-blue-600 hover:bg-blue-700"
          >
            Log In
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-ticker-bg text-ticker-text">
      <div className="container mx-auto p-4">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Sports Ticker Control</h1>
          <UserProfile />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h2 className="text-xl font-bold mb-6">Select Kit</h2>
            <KitSelector 
              activeKit={activeKit}
              onKitSelect={handleKitSelect}
              onApplyChanges={handleApplyChanges}
              hasUnsavedChanges={hasUnsavedChanges}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
